const SVG_RENDER_SCALE = 4

export interface RenderedImage {
  dataUrl: string
  width: number
  height: number
}

export const svgToPngDataUrl = (svgUrl: string, svgWidth: number, svgHeight: number): Promise<RenderedImage> => {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas')
    const pxWidth = svgWidth * SVG_RENDER_SCALE
    const pxHeight = svgHeight * SVG_RENDER_SCALE
    canvas.width = pxWidth
    canvas.height = pxHeight
    const ctx = canvas.getContext('2d')
    if (!ctx) return reject(new Error('Canvas context unavailable'))

    const img = new Image()
    img.onload = () => {
      ctx.drawImage(img, 0, 0, pxWidth, pxHeight)
      resolve({ dataUrl: canvas.toDataURL('image/png'), width: pxWidth, height: pxHeight })
    }
    img.onerror = () => reject(new Error('Failed to load SVG'))
    img.src = svgUrl
  })
}

export const parseSvgDimensions = (svgText: string): { width: number; height: number } | null => {
  const viewBoxMatch = svgText.match(/viewBox=["'](-?[\d.]+[\s,]+-?[\d.]+[\s,]+([\d.]+)[\s,]+([\d.]+))["']/)
  const widthMatch = svgText.match(/\bwidth=["'](\d+(?:\.\d+)?)["']/)
  const heightMatch = svgText.match(/\bheight=["'](\d+(?:\.\d+)?)["']/)

  const width = viewBoxMatch ? parseFloat(viewBoxMatch[2]) : widthMatch ? parseFloat(widthMatch[1]) : 0
  const height = viewBoxMatch ? parseFloat(viewBoxMatch[3]) : heightMatch ? parseFloat(heightMatch[1]) : 0

  if (!width || !height) return null
  return { width, height }
}
